import { MutableRefObject, useLayoutEffect, useRef, useState } from 'react';
import { scroller } from 'react-scroll';

// The caller is responsible for visually clamping the content (e.g. via CSS
// `-webkit-line-clamp` on the element receiving `truncatedContentRef`). This hook
// only measures whether the content overflows that clamp — if `scrollHeight`
// exceeds `clientHeight`, `truncatable` flips true so the caller can render a
// Read More / Read Less control wired to `handleToggleTruncation`.
export const useTruncatedComment = (
  scrollTargetId: string,
  body: string | null | undefined
): {
  handleToggleTruncation: () => void;
  truncatable: boolean;
  truncated: boolean;
  truncatedContentRef: MutableRefObject<HTMLDivElement | null>;
} => {
  const [truncated, setTruncated] = useState(true);
  const [truncatable, setTruncatable] = useState(true);

  const truncatedContentRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const element = truncatedContentRef.current;
    if (!element || !truncated) return;

    const previousDisplay = element.style.display;
    element.style.display = 'block';

    const fullHeight = element.scrollHeight;
    element.style.display = previousDisplay;

    setTruncatable(fullHeight > element.clientHeight);
  }, [body, truncated]);

  const handleToggleTruncation = (): void => {
    if (!truncated) {
      scroller.scrollTo(scrollTargetId, {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuint',
        offset: -(65 + 45 + 15) // -(top navigation height + idea / wp show page navigator height + some padding)
      });
    }
    setTruncated(!truncated);
  };

  return {
    handleToggleTruncation,
    truncatable,
    truncated,
    truncatedContentRef
  };
};
